import { render, staticRenderFns } from "./ProjectData.vue?vue&type=template&id=64131949"
import script from "./ProjectData.vue?vue&type=script&lang=ts"
export * from "./ProjectData.vue?vue&type=script&lang=ts"
import style0 from "./ProjectData.vue?vue&type=style&index=0&id=64131949&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports